// extracted by mini-css-extract-plugin
export default {"svg":"ServiceCard_svg__kEKXr","avatar":"ServiceCard_avatar__9MYGz"};